module.exports = __webpack_public_path__ + "img/38.3827e6b6.png";